// extracted by mini-css-extract-plugin
export default {"button_programming":"Programming_button_programming__SK1hh"};